import { WidgetRendererBase } from "../widget-renderer-base";
import { ISearchResultsWidgetData, ISearchResultsWidgetRenderingData, SearchResultsWidgetData } from "@pageBuilder/typings";
import { Base64Util } from "src/utils/base64-util";
import { SearchResultsStyleRenderer } from "./search-results-style-renderer";
import { SearchResultsWidgetScriptRenderer } from "./search-results-widget-script-renderer";
import { IRenderingCommonContext } from "@commonRendering/types";

export class SearchResultsWidgetRenderer extends WidgetRendererBase<ISearchResultsWidgetData> {

    private readonly styleRenderer: SearchResultsStyleRenderer;
    private readonly scriptRenderer: SearchResultsWidgetScriptRenderer;

    private readonly RENDERING_DATA_ATTRIBUTE = "data-search-results";

    constructor(renderingCommonContext: IRenderingCommonContext) {
        super(renderingCommonContext);
        this.styleRenderer = new SearchResultsStyleRenderer(this.styleService);
        this.scriptRenderer = new SearchResultsWidgetScriptRenderer();
    }

    protected createNewInternal(): HTMLElement {
        return this.createWidgetElement("searchResultsWidget");
    }

    protected renderInternal(element: HTMLElement, data: ISearchResultsWidgetData): HTMLElement {
        const previousData = this.getData(element);
        if (previousData && previousData.showSearchBox !== data.showSearchBox && data.showSearchBox) {
            data.style.searchBoxStyle = SearchResultsWidgetData.defaultStyle.searchBoxStyle;
        }

        this.setAttributes(element, data);
        this.renderStyles(element, data);
        this.renderScript(element, previousData, data);

        return element;
    }

    private setAttributes(element: HTMLElement, data: ISearchResultsWidgetData): void {
        const renderingData: ISearchResultsWidgetRenderingData = {
            showSearchBox: data.showSearchBox,
            searchBoxPlaceholder: data.searchBoxPlaceholder,
            resultsPerPage: data.resultsPerPage
        };

        const json = Base64Util.serialize(renderingData) || "";
        element.setAttribute(this.RENDERING_DATA_ATTRIBUTE, json);

        if (this.getRenderingMode() !== "published") {
            element.setAttribute("data-stubs-info", "");
            element.dataset.draft = "true";
        }
    }

    private renderScript(element: HTMLElement, previousData: ISearchResultsWidgetData | null, data: ISearchResultsWidgetData): void {
        if (!SearchResultsWidgetData.localScriptRerenderNeeded(previousData ?? undefined, data)) {
            this.scriptRenderer.renderLocal(element);
        }
    }

    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    protected override cleanupInternal(element: HTMLElement): void {
        // nothing
    }

    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    protected override getContentSelectorsInternal(element: HTMLElement): string[] {
        return [];
    }

    protected override renderStyles(element: HTMLElement, data: ISearchResultsWidgetData): void {
        this.animationRenderer.setAnimationStyles(element, data.style.animation);
        this.styleRenderer.render(element, data.style, data.showSearchBox);
    }

}
